import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  campaignsRoot: {
    // TODO: Eliminé flex direction column
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    background: "transparent"
  },

  messageContainer: {
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  },
  message: {
    color: theme.palette.text.disabled,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: "center"
  }
}));
